import { frontendURL } from 'dashboard/helper/URLHelper';
import KanbanBoard from './KanbanBoard.vue';
import KanbanFunnels from './KanbanFunnels.vue';
import KanbanCardDetail from './KanbanCardDetail.vue';
import KanbanFlows from './KanbanFlows.vue';
import KanbanFlowBuilder from './KanbanFlowBuilder.vue';
import KanbanReports from './KanbanReports.vue';
import KanbanCalls from './KanbanCalls.vue';
import KanbanProjects from './KanbanProjects.vue';
import KanbanProjectDetail from './KanbanProjectDetail.vue';
import KanbanFlowHistory from './KanbanFlowHistory.vue';
import KanbanFlowExecutionDetail from './KanbanFlowExecutionDetail.vue';
import KanbanAppointments from './KanbanAppointments.vue';
import KanbanCampaigns from './KanbanCampaigns.vue';
import KanbanCampaignWizard from './KanbanCampaignWizard.vue';
import KanbanCampaignDetail from './KanbanCampaignDetail.vue';
import KanbanEmail from './KanbanEmail.vue';
import KanbanEmailWizard from './KanbanEmailWizard.vue';
import KanbanEmailReport from './KanbanEmailReport.vue';
import KanbanChats from './KanbanChats.vue';
import KanbanConnections from './KanbanConnections.vue';

// Editor de template carrega o GrapesJS (pesado) → lazy-import por rota.
const KanbanEmailTemplateEditor = () =>
  import('./KanbanEmailTemplateEditor.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_home',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanBoard,
  },
  {
    path: frontendURL('accounts/:accountId/kanban/funnels'),
    name: 'kanban_funnels',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanFunnels,
  },
  {
    path: frontendURL('accounts/:accountId/kanban/cards/:cardId'),
    name: 'kanban_card_detail',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanCardDetail,
  },
  {
    path: frontendURL('accounts/:accountId/flows'),
    name: 'kanban_flows',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanFlows,
  },
  {
    path: frontendURL('accounts/:accountId/crm-reports'),
    name: 'kanban_reports',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanReports,
  },
  {
    path: frontendURL('accounts/:accountId/calls-report'),
    name: 'kanban_calls',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanCalls,
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history/:executionId'),
    name: 'kanban_flow_execution_detail',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanFlowExecutionDetail,
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/history'),
    name: 'kanban_flow_history',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanFlowHistory,
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId'),
    name: 'kanban_flow_builder',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanFlowBuilder,
  },
  {
    path: frontendURL('accounts/:accountId/projects'),
    name: 'kanban_projects',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanProjects,
  },
  {
    path: frontendURL('accounts/:accountId/projects/:projectId'),
    name: 'kanban_project_detail',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanProjectDetail,
  },
  {
    path: frontendURL('accounts/:accountId/appointments'),
    name: 'kanban_appointments',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanAppointments,
  },
  {
    path: frontendURL('accounts/:accountId/disparador'),
    name: 'kanban_campaigns',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanCampaigns,
  },
  {
    path: frontendURL('accounts/:accountId/disparador/new'),
    name: 'kanban_campaign_wizard',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanCampaignWizard,
  },
  {
    path: frontendURL('accounts/:accountId/disparador/:campaignId'),
    name: 'kanban_campaign_detail',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanCampaignDetail,
  },
  {
    path: frontendURL('accounts/:accountId/email'),
    name: 'kanban_email',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanEmail,
  },
  {
    path: frontendURL('accounts/:accountId/email/new'),
    name: 'kanban_email_wizard',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanEmailWizard,
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/new'),
    name: 'kanban_email_template_new',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanEmailTemplateEditor,
  },
  {
    path: frontendURL('accounts/:accountId/email/templates/:templateId'),
    name: 'kanban_email_template',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanEmailTemplateEditor,
  },
  {
    path: frontendURL('accounts/:accountId/email/:campaignId'),
    name: 'kanban_email_report',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanEmailReport,
  },
  {
    path: frontendURL('accounts/:accountId/internal-chats'),
    name: 'kanban_internal_chats',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: KanbanChats,
  },
  {
    path: frontendURL('accounts/:accountId/connections'),
    name: 'kanban_connections',
    meta: { permissions: ['administrator', 'custom_role'] },
    component: KanbanConnections,
  },
];
